import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SideBar from "../components/SideBar";
import Tab from "../components/Tab";
import styles from "../styles/tabs.module.css";
import Footer from "../components/Footer";
import { faUser, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faBell, faComment } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Breadcrumbs from "../components/Breadcrumbs";
import UserIcon from "../components/UserIcon";

function Pages(props) {
  const handleCheck = (e) => {
    setSelectedTab(e.target.value);
  };

  const tabs = {
    1: "Home Page",
    2: "Products Page",
    3: "Contact Us Page",
    4: "Who We Are Page",
    5: "Privacy Policy",
    6: "Careers",
  };
  let { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  let tab = queryParams.get("tab");
  const [selectedTab, setSelectedTab] = useState(tab);

  useEffect(() => {
    setSelectedTab(queryParams.get("tab"));
  }, [tab]);

  return (
    <div className="w-[96%] text-[17px] m-auto mt-6">
      <div className="m-auto mt-6 flex">
        <div>
          <SideBar />
        </div>
        <div className="w-full flex flex-col ml-6 text-[#033362] font-semibold">
          <div className="flex justify-between items-center w-full">
            <Breadcrumbs
              breads={[
                {
                  title: "Pages",
                  link: "/pages?tab=1",
                },
              ]}
            />
            <div className="flex items-center h-8 w-[30%]">
              <UserIcon/>
            </div>
          </div>
          <div className="bg-[white] grow mt-2 rounded-xl shadow-[0px_0px_16px_rgb(210,215,211)]">
            <div className={`${styles.tabs} rounded-xl`}>
              <div
                className={`${styles.tab} rounded-tl-xl pl-[20px] text-[18px] py-[10px] ${styles.selected}`}
              >
                {tabs[selectedTab]}
              </div>
              <Tab
                content="HomePage"
                selectedTab={selectedTab}
                labelId="label-1"
                title="Home Page"
                value="1"
                handleCheck={handleCheck}
                url="/pages?tab=1"
              />
              <Tab
                content="ProductsPage"
                selectedTab={selectedTab}
                title="Products Page"
                value="2"
                handleCheck={handleCheck}
                url="/pages?tab=2"
              />
              <Tab
                content="ContactUsPage"
                selectedTab={selectedTab}
                title="Contact Us Page"
                value="3"
                handleCheck={handleCheck}
                url="/pages?tab=3"
              />
              <Tab
                content="WhoWeArePage"
                selectedTab={selectedTab}
                title="Who We Are Page"
                value="4"
                handleCheck={handleCheck}
                url="/pages?tab=4"
              />
              <Tab
                content="PrivacyPolicy"
                selectedTab={selectedTab}
                title="Privacy Policy"
                value="5"
                handleCheck={handleCheck}
                url="/pages?tab=5"
              />
              <Tab
                content="Careers"
                selectedTab={selectedTab}
                title="Careers"
                value="6"
                handleCheck={handleCheck}
                url="/pages?tab=6"
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Pages;
